module.exports = __webpack_public_path__ + "static/media/headerLogo.b4c55509.png";